
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

export default function CoursesPage() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const courseCategories = [
    { id: 'all', name: '全部课程', count: 21 },
    { id: 'accounting', name: '会计基础', count: 7 },
    { id: 'tax', name: '税务专业', count: 6 },
    { id: 'finance', name: '财务管理', count: 3 },
    { id: 'digital', name: '数字化技能', count: 3 },
    { id: 'intelligent', name: '智能财税', count: 2 }
  ];

  const courses = [
    // 会计基础类
    {
      id: 1,
      name: '会计基础',
      category: 'accounting',
      level: '基础',
      duration: '48学时',
      students: 1856,
      rating: 4.8,
      description: '掌握会计学基本理论、基本方法和基本技能，为后续专业课程学习奠定坚实基础',
      instructor: '张教授',
      tags: ['理论基础', '实务操作', '核心课程'],
      image: 'https://public.readdy.ai/ai/img_res/7b98d567d8f2d6c1ff03c7720449b6db.jpg'
    },
    {
      id: 2,
      name: '税务会计',
      category: 'accounting',
      level: '中级',
      duration: '64学时',
      students: 1432,
      rating: 4.7,
      description: '学习税务会计的基本理论和实务操作，掌握各种税种的会计处理方法',
      instructor: '李教授',
      tags: ['税务处理', '实务操作', '专业核心'],
      image: 'https://readdy.ai/api/search-image?query=Tax%20accounting%20workspace%20with%20tax%20forms%2C%20financial%20documents%2C%20computer%20showing%20tax%20software%2C%20professional%20office%20environment%20with%20organized%20filing%20system&width=400&height=240&seq=course-tax-accounting&orientation=landscape'
    },
    {
      id: 3,
      name: '管理会计',
      category: 'accounting',
      level: '中级',
      duration: '56学时',
      students: 1298,
      rating: 4.6,
      description: '学习管理会计的理论与方法，掌握成本控制、预算管理、绩效评价等核心技能',
      instructor: '王教授',
      tags: ['成本管理', '预算控制', '绩效评价'],
      image: 'https://readdy.ai/api/search-image?query=Management%20accounting%20office%20with%20charts%2C%20graphs%2C%20budget%20reports%2C%20business%20analysis%20tools%2C%20modern%20corporate%20environment%20with%20professional%20atmosphere&width=400&height=240&seq=course-management-accounting&orientation=landscape'
    },
    {
      id: 4,
      name: '行政事业单位会计',
      category: 'accounting',
      level: '中级',
      duration: '48学时',
      students: 987,
      rating: 4.5,
      description: '学习政府会计制度，掌握行政事业单位的会计核算方法和财务管理要求',
      instructor: '陈教授',
      tags: ['政府会计', '事业单位', '公共财务'],
      image: 'https://readdy.ai/api/search-image?query=Government%20accounting%20office%20with%20official%20documents%2C%20public%20sector%20financial%20reports%2C%20administrative%20workspace%20with%20formal%20professional%20setting&width=400&height=240&seq=course-gov-accounting&orientation=landscape'
    },
    {
      id: 5,
      name: '企业财务管理',
      category: 'finance',
      level: '中级',
      duration: '64学时',
      students: 1654,
      rating: 4.9,
      description: '学习企业财务管理理论与实务，掌握投资决策、融资决策、股利政策等核心内容',
      instructor: '刘教授',
      tags: ['投资决策', '融资管理', '财务分析'],
      image: 'https://readdy.ai/api/search-image?query=Corporate%20finance%20office%20with%20financial%20charts%2C%20investment%20analysis%20documents%2C%20modern%20business%20environment%20with%20professional%20financial%20planning%20setup&width=400&height=240&seq=course-corporate-finance&orientation=landscape'
    },
    {
      id: 6,
      name: '企业内部控制与风险管理',
      category: 'finance',
      level: '高级',
      duration: '48学时',
      students: 1123,
      rating: 4.7,
      description: '学习企业内部控制制度设计与实施，掌握风险识别、评估和控制的方法与技能',
      instructor: '赵教授',
      tags: ['内部控制', '风险管理', '合规管理'],
      image: 'https://readdy.ai/api/search-image?query=Risk%20management%20office%20with%20control%20frameworks%2C%20compliance%20documents%2C%20audit%20materials%2C%20professional%20corporate%20governance%20environment&width=400&height=240&seq=course-risk-management&orientation=landscape'
    },
    {
      id: 7,
      name: '财务审计',
      category: 'finance',
      level: '高级',
      duration: '56学时',
      students: 1345,
      rating: 4.8,
      description: '学习财务审计的理论与实务，掌握审计程序、审计方法和审计报告编制技能',
      instructor: '孙教授',
      tags: ['审计程序', '审计方法', '审计报告'],
      image: 'https://readdy.ai/api/search-image?query=Financial%20audit%20office%20with%20audit%20documents%2C%20examination%20materials%2C%20professional%20auditing%20workspace%20with%20organized%20files%20and%20analysis%20tools&width=400&height=240&seq=course-financial-audit&orientation=landscape'
    },
    // 税务专业类
    {
      id: 8,
      name: '税法',
      category: 'tax',
      level: '基础',
      duration: '48学时',
      students: 1789,
      rating: 4.6,
      description: '学习税法基本理论和各税种的法律规定，为税务实务操作奠定法律基础',
      instructor: '周教授',
      tags: ['税法理论', '税种分析', '法律基础'],
      image: 'https://readdy.ai/api/search-image?query=Tax%20law%20classroom%20with%20legal%20books%2C%20tax%20code%20documents%2C%20professional%20legal%20education%20environment%20with%20students%20studying%20tax%20regulations&width=400&height=240&seq=course-tax-law&orientation=landscape'
    },
    {
      id: 9,
      name: '税务合规',
      category: 'tax',
      level: '中级',
      duration: '40学时',
      students: 1234,
      rating: 4.5,
      description: '学习税务合规管理体系，掌握企业税务风险防控和合规管理的方法与技能',
      instructor: '吴教授',
      tags: ['合规管理', '风险防控', '税务筹划'],
      image: 'https://readdy.ai/api/search-image?query=Tax%20compliance%20office%20with%20regulatory%20documents%2C%20compliance%20checklists%2C%20professional%20tax%20advisory%20workspace%20with%20organized%20legal%20materials&width=400&height=240&seq=course-tax-compliance&orientation=landscape'
    },
    {
      id: 10,
      name: '纳税检查',
      category: 'tax',
      level: '中级',
      duration: '32学时',
      students: 876,
      rating: 4.4,
      description: '学习纳税检查的程序和方法，掌握税务稽查应对和自查自纠的技能',
      instructor: '郑教授',
      tags: ['税务稽查', '检查程序', '应对策略'],
      image: 'https://readdy.ai/api/search-image?query=Tax%20inspection%20office%20with%20examination%20documents%2C%20audit%20trails%2C%20professional%20tax%20investigation%20workspace%20with%20detailed%20analysis%20materials&width=400&height=240&seq=course-tax-inspection&orientation=landscape'
    },
    {
      id: 11,
      name: '纳税申报实训',
      category: 'tax',
      level: '实践',
      duration: '40学时',
      students: 1567,
      rating: 4.7,
      description: '通过实际操作训练，掌握各税种的纳税申报流程和申报表填写技能',
      instructor: '钱教授',
      tags: ['实训操作', '申报流程', '实务技能'],
      image: 'https://readdy.ai/api/search-image?query=Tax%20filing%20training%20lab%20with%20computers%20showing%20tax%20software%2C%20students%20practicing%20tax%20return%20preparation%2C%20modern%20educational%20technology%20environment&width=400&height=240&seq=course-tax-filing&orientation=landscape'
    },
    {
      id: 12,
      name: '税收征管流程实训',
      category: 'tax',
      level: '实践',
      duration: '32学时',
      students: 1098,
      rating: 4.6,
      description: '学习税收征管的完整流程，通过实训掌握征管各环节的操作要点',
      instructor: '冯教授',
      tags: ['征管流程', '实训操作', '流程管理'],
      image: 'https://readdy.ai/api/search-image?query=Tax%20administration%20training%20center%20with%20workflow%20diagrams%2C%20process%20documentation%2C%20professional%20government%20tax%20office%20simulation%20environment&width=400&height=240&seq=course-tax-admin&orientation=landscape'
    },
    {
      id: 13,
      name: '智慧化税费申报与管理',
      category: 'tax',
      level: '高级',
      duration: '48学时',
      students: 1432,
      rating: 4.8,
      description: '学习智慧税务系统的应用，掌握数字化税费申报和智能化税务管理技能',
      instructor: '蒋教授',
      tags: ['智慧税务', '数字化申报', '智能管理'],
      image: 'https://readdy.ai/api/search-image?query=Smart%20tax%20management%20office%20with%20digital%20interfaces%2C%20AI-powered%20tax%20systems%2C%20modern%20technology%20workspace%20with%20automated%20tax%20processing%20tools&width=400&height=240&seq=course-smart-tax&orientation=landscape'
    },
    // 数字化技能类
    {
      id: 14,
      name: '财务大数据基础',
      category: 'digital',
      level: '基础',
      duration: '40学时',
      students: 1345,
      rating: 4.5,
      description: '学习大数据技术基础知识，了解大数据在财务领域的应用场景和发展趋势',
      instructor: '韩教授',
      tags: ['大数据基础', '财务应用', '技术趋势'],
      image: 'https://readdy.ai/api/search-image?query=Big%20data%20classroom%20with%20data%20visualization%20screens%2C%20students%20learning%20data%20analytics%2C%20modern%20computer%20lab%20with%20financial%20data%20analysis%20tools&width=400&height=240&seq=course-big-data-basic&orientation=landscape'
    },
    {
      id: 15,
      name: '财税大数据分析',
      category: 'digital',
      level: '中级',
      duration: '56学时',
      students: 1567,
      rating: 4.9,
      description: '学习大数据分析方法和工具，掌握财税数据的采集、处理、分析和可视化技能',
      instructor: '杨教授',
      tags: ['数据分析', '可视化', '分析工具'],
      image: 'https://readdy.ai/api/search-image?query=Data%20analysis%20lab%20with%20multiple%20monitors%20showing%20financial%20charts%2C%20data%20visualization%20tools%2C%20modern%20analytics%20workspace%20with%20big%20data%20processing%20systems&width=400&height=240&seq=course-data-analysis&orientation=landscape'
    },
    {
      id: 16,
      name: 'Excel在财务中的应用',
      category: 'digital',
      level: '实践',
      duration: '32学时',
      students: 1876,
      rating: 4.7,
      description: '深入学习Excel在财务工作中的高级应用，掌握财务建模和数据分析技能',
      instructor: '朱教授',
      tags: ['Excel技能', '财务建模', '数据处理'],
      image: 'https://readdy.ai/api/search-image?query=Excel%20training%20classroom%20with%20computers%20showing%20financial%20spreadsheets%2C%20students%20learning%20advanced%20Excel%20functions%2C%20professional%20office%20training%20environment&width=400&height=240&seq=course-excel-finance&orientation=landscape'
    },
    // 智能财税类
    {
      id: 17,
      name: '财税机器人开发与维护',
      category: 'intelligent',
      level: '高级',
      duration: '64学时',
      students: 987,
      rating: 4.8,
      description: '学习财税机器人的开发原理和维护方法，掌握RPA技术在财税领域的应用',
      instructor: '徐教授',
      tags: ['RPA技术', '机器人开发', '自动化'],
      image: 'https://readdy.ai/api/search-image?query=Robotics%20development%20lab%20with%20programming%20workstations%2C%20automation%20systems%2C%20modern%20tech%20environment%20for%20financial%20robot%20development&width=400&height=240&seq=course-tax-robot&orientation=landscape'
    },
    {
      id: 18,
      name: '业财管理信息系统应用',
      category: 'intelligent',
      level: '中级',
      duration: '48学时',
      students: 1234,
      rating: 4.6,
      description: '学习企业业财一体化信息系统的应用，掌握系统操作和业务流程优化技能',
      instructor: '胡教授',
      tags: ['信息系统', '业财一体化', '流程优化'],
      image: 'https://readdy.ai/api/search-image?query=Enterprise%20information%20system%20training%20room%20with%20ERP%20interfaces%2C%20business%20process%20diagrams%2C%20modern%20corporate%20IT%20training%20environment&width=400&height=240&seq=course-erp-system&orientation=landscape'
    },
    {
      id: 19,
      name: '智能化税务管理',
      category: 'intelligent',
      level: '高级',
      duration: '40学时',
      students: 876,
      rating: 4.7,
      description: '学习AI技术在税务管理中的应用，掌握智能化税务决策和管理方法',
      instructor: '林教授',
      tags: ['AI应用', '智能决策', '税务管理'],
      image: 'https://readdy.ai/api/search-image?query=AI%20tax%20management%20center%20with%20intelligent%20dashboards%2C%20machine%20learning%20interfaces%2C%20futuristic%20tax%20technology%20workspace&width=400&height=240&seq=course-ai-tax&orientation=landscape'
    },
    {
      id: 20,
      name: '大数据技术在财务中的应用',
      category: 'digital',
      level: '高级',
      duration: '56学时',
      students: 1123,
      rating: 4.8,
      description: '深入学习大数据技术在财务管理中的具体应用，掌握数据挖掘和预测分析技能',
      instructor: '何教授',
      tags: ['数据挖掘', '预测分析', '技术应用'],
      image: 'https://readdy.ai/api/search-image?query=Advanced%20big%20data%20lab%20with%20data%20mining%20tools%2C%20predictive%20analytics%20systems%2C%20high-tech%20financial%20data%20processing%20environment&width=400&height=240&seq=course-big-data-advanced&orientation=landscape'
    },
    {
      id: 21,
      name: '智能财税',
      category: 'intelligent',
      level: '高级',
      duration: '48学时',
      students: 1345,
      rating: 4.9,
      description: '综合学习智能财税的理论与实践，掌握人工智能在财税领域的前沿应用',
      instructor: '罗教授',
      tags: ['人工智能', '前沿技术', '综合应用'],
      image: 'https://readdy.ai/api/search-image?query=Intelligent%20finance%20and%20tax%20center%20with%20AI%20systems%2C%20smart%20analytics%20platforms%2C%20cutting-edge%20technology%20workspace%20for%20financial%20innovation&width=400&height=240&seq=course-intelligent-finance&orientation=landscape'
    }
  ];

  const filteredCourses = courses.filter(course => {
    const matchesCategory = selectedCategory === 'all' || course.category === selectedCategory;
    const matchesSearch = course.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         course.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         course.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    return matchesCategory && matchesSearch;
  });

  const getLevelColor = (level: string) => {
    switch (level) {
      case '基础': return 'bg-green-100 text-green-800';
      case '中级': return 'bg-blue-100 text-blue-800';
      case '高级': return 'bg-purple-100 text-purple-800';
      case '实践': return 'bg-orange-100 text-orange-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="py-16 bg-gradient-to-br from-blue-50 to-indigo-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                财税大数据专业课程
              </h1>
              <p className="text-xl text-gray-600 max-w-4xl mx-auto mb-8">
                系统化的课程体系，涵盖会计基础、税务专业、财务管理、数字化技能和智能财税五大核心领域，
                培养具备现代财税理论知识和数字化实践技能的复合型人才
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <div className="bg-white rounded-lg px-6 py-3 shadow-sm">
                  <div className="text-2xl font-bold text-blue-600">{courses.length}</div>
                  <div className="text-sm text-gray-600">门课程</div>
                </div>
                <div className="bg-white rounded-lg px-6 py-3 shadow-sm">
                  <div className="text-2xl font-bold text-green-600">1000+</div>
                  <div className="text-sm text-gray-600">学时</div>
                </div>
                <div className="bg-white rounded-lg px-6 py-3 shadow-sm">
                  <div className="text-2xl font-bold text-purple-600">28K+</div>
                  <div className="text-sm text-gray-600">学习人次</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Filters and Search */}
        <section className="py-8 bg-white border-b">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col lg:flex-row gap-6 items-center justify-between">
              {/* Category Filters */}
              <div className="flex flex-wrap gap-2">
                {courseCategories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => setSelectedCategory(category.id)}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                      selectedCategory === category.id
                        ? 'bg-blue-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    {category.name} ({category.count})
                  </button>
                ))}
              </div>

              {/* Search */}
              <div className="relative w-full lg:w-80">
                <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                <input
                  type="text"
                  placeholder="搜索课程名称、描述或标签..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Course Grid */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                {selectedCategory === 'all' ? '全部课程' : courseCategories.find(c => c.id === selectedCategory)?.name}
              </h2>
              <p className="text-gray-600">
                找到 {filteredCourses.length} 门课程
                {searchTerm && ` · 搜索关键词: "${searchTerm}"`}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredCourses.map((course) => (
                <Card key={course.id} hover className="h-full">
                  <div className="relative">
                    <img 
                      src={course.image} 
                      alt={course.name}
                      className="w-full h-48 object-cover object-top rounded-lg mb-4"
                    />
                    <div className={`absolute top-4 left-4 px-2 py-1 rounded-md text-xs font-medium ${getLevelColor(course.level)}`}>
                      {course.level}
                    </div>
                    <div className="absolute top-4 right-4 bg-white bg-opacity-90 rounded-md px-2 py-1">
                      <div className="flex items-center gap-1">
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        <span className="text-sm font-medium">{course.rating}</span>
                      </div>
                    </div>
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{course.name}</h3>
                  <p className="text-gray-600 mb-4 text-sm leading-relaxed line-clamp-3">{course.description}</p>
                  
                  <div className="space-y-3 mb-4">
                    <div className="flex items-center justify-between text-sm text-gray-500">
                      <div className="flex items-center gap-1">
                        <i className="ri-user-line"></i>
                        <span>{course.instructor}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        <span>{course.duration}</span>
                      </div>
                    </div>
                    
                    <div className="flex items-center justify-between text-sm text-gray-500">
                      <div className="flex items-center gap-1">
                        <i className="ri-group-line"></i>
                        <span>{course.students.toLocaleString()}人学习</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex flex-wrap gap-2 mb-4">
                    {course.tags.map((tag, index) => (
                      <span 
                        key={index}
                        className="px-2 py-1 bg-gray-100 text-gray-700 rounded-md text-xs"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>

                  <div className="mt-auto pt-4 border-t border-gray-100">
                    <div className="flex gap-2">
                      <Link 
                        to={course.id === 8 ? "/course-tax-law" : "#"}
                        className="flex-1"
                      >
                        <Button className="w-full" size="sm">
                          <i className="ri-play-circle-line mr-2"></i>
                          开始学习
                        </Button>
                      </Link>
                      <Button variant="outline" size="sm">
                        <i className="ri-bookmark-line"></i>
                      </Button>
                    </div>
                  </div>
                </Card>
              ))}
            </div>

            {filteredCourses.length === 0 && (
              <div className="text-center py-16">
                <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">未找到相关课程</h3>
                <p className="text-gray-600 mb-6">
                  尝试调整搜索关键词或选择其他课程分类
                </p>
                <Button onClick={() => { setSearchTerm(''); setSelectedCategory('all'); }}>
                  查看全部课程
                </Button>
              </div>
            )}
          </div>
        </section>

        {/* Course Statistics */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                课程体系统计
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                完整的财税大数据专业课程体系，覆盖理论基础到实践应用的全方位培养
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
              {courseCategories.slice(1).map((category, index) => {
                const categoryColors = [
                  'from-blue-500 to-blue-600',
                  'from-green-500 to-green-600', 
                  'from-purple-500 to-purple-600',
                  'from-teal-500 to-teal-600',
                  'from-orange-500 to-orange-600'
                ];
                
                return (
                  <Card key={category.id} className="text-center">
                    <div className={`w-16 h-16 bg-gradient-to-br ${categoryColors[index]} rounded-full flex items-center justify-center text-white text-2xl font-bold mx-auto mb-4`}>
                      {category.count}
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{category.name}</h3>
                    <p className="text-sm text-gray-600">
                      {category.count} 门专业课程
                    </p>
                  </Card>
                );
              })}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}